/**
 * CDP — Média HLC e Desvios.
 *
 * Migrado do Silverlight (GraficoDePrata/Formulas/FMLBands.cs, classe
 * FML.CDP). Overlay de preço, 5 linhas, SEM parâmetros:
 *
 *   PT  = REF(H,1) − REF(L,1)         (amplitude da barra anterior)
 *   CDP = (H + L + C) / 3
 *   AH  = CDP + PT     AL = CDP − PT
 *   NH  = 2·CDP − L    NL = 2·CDP − H
 *
 * Pacote na ordem [CDP, AH, AL, NH, NL] — é essa ordem que define a cor
 * default de cada linha (paleta por índice do engine). Paridade provada em
 * __tests__/cdp.silverlight.test.js.
 */
import { add, sub, mul, div, ref } from "./silverlightDsl";

export default function () {
  let options = {};

  function calculator(data) {
    const num = (v) => (Number.isFinite(v) ? v : NaN);
    const high = data.map((d) => num(d.high));
    const low = data.map((d) => num(d.low));
    const close = data.map((d) => num(d.close));

    const pt = sub(ref(high, 1), ref(low, 1));
    const cdp = div(add(add(high, low), close), 3);
    const ah = add(cdp, pt);
    const al = sub(cdp, pt);
    const nh = sub(mul(cdp, 2), low);
    const nl = sub(mul(cdp, 2), high);

    const out = (arr, i) => (Number.isFinite(arr[i]) ? arr[i] : undefined);

    return cdp.map((_, i) => {
      const v = {
        cdp: out(cdp, i),
        ah: out(ah, i),
        al: out(al, i),
        nh: out(nh, i),
        nl: out(nl, i),
      };
      return Object.values(v).every((x) => x === undefined) ? undefined : v;
    });
  }

  calculator.undefinedLength = function () {
    // CDP/NH/NL emitem desde a barra 0; só AH/AL dependem do REF(·,1).
    return 0;
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...x };
    return calculator;
  };

  return calculator;
}
